// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1446":"24b05b48","3026":"56661f28","5836":"11c5b3d1","6268":"40486d19"}[chunkId] + ".chunk.css";
};